import { useEffect, useState } from "react";
import { Card, Tabs, Table, Input, Button, Modal, Space, Typography, Tag } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import SideBar from "../../../components/SideBar";
import NavBar from "../../../components/NavBar";
import Footer from "../../../components/Footer";
import axiosInstance from "../../../variables/api/axiosInstance";

const { Title, Text } = Typography;
const PRIMARY = "#242166";

// Motifs d'exclusion de la rétrocession, PAR TYPE de ligne (paramétrables).
const TYPES = [
    { key: "SINISTRE", label: "Sinistres payés", param: "MOTIF_EXCLUSION_RETRO_SINISTRE" },
    { key: "EMISSION", label: "Émissions", param: "MOTIF_EXCLUSION_RETRO_EMISSION" },
    { key: "ANNULATION", label: "Annulations", param: "MOTIF_EXCLUSION_RETRO_ANNULATION" },
    { key: "RECOURS", label: "Recours", param: "MOTIF_EXCLUSION_RETRO_RECOURS" },
];

const MotifsParType = ({ paramType }) => {
    const [motifs, setMotifs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [libelle, setLibelle] = useState("");
    const [saving, setSaving] = useState(false);

    const fetch = () => {
        setLoading(true);
        axiosInstance.get(`/api/parametre/type/${paramType}`)
            .then((res) => setMotifs((res.data || []).sort((a, b) => b.parametreId - a.parametreId)))
            .catch(() => setMotifs([]))
            .finally(() => setLoading(false));
    };
    useEffect(() => { fetch(); /* eslint-disable-next-line */ }, [paramType]);

    const ajouter = () => {
        const val = libelle.trim();
        if (!val) return;
        if (motifs.some((m) => (m.libelleParametre || "").trim().toLowerCase() === val.toLowerCase())) {
            toast.error("Ce motif existe déjà."); return;
        }
        setSaving(true);
        axiosInstance.post(`/api/parametre`, { libelleParametre: val, typeParametre: paramType })
            .then((res) => { setMotifs((prev) => [res.data, ...prev]); setLibelle(""); toast.success("Motif ajouté."); })
            .catch(() => toast.error("Échec de l'ajout."))
            .finally(() => setSaving(false));
    };

    const supprimer = (record) => {
        Modal.confirm({
            title: "Supprimer ce motif ?",
            content: record.libelleParametre,
            okText: "Supprimer", okType: "danger", cancelText: "Annuler",
            onOk: () => axiosInstance.delete(`/api/parametre/${record.parametreId}`)
                .then(() => { setMotifs((prev) => prev.filter((m) => m.parametreId !== record.parametreId)); toast.success("Motif supprimé."); })
                .catch(() => toast.error("Échec de la suppression.")),
        });
    };

    return (
        <div>
            <Space.Compact style={{ width: "100%", maxWidth: 560, marginBottom: 14 }}>
                <Input value={libelle} onChange={(e) => setLibelle(e.target.value)}
                    onPressEnter={ajouter} placeholder="Nouveau motif d'exclusion…" />
                <Button type="primary" icon={<PlusOutlined />} loading={saving} onClick={ajouter}>Ajouter</Button>
            </Space.Compact>
            <Table rowKey="parametreId" size="small" loading={loading} pagination={false} dataSource={motifs}
                locale={{ emptyText: "Aucun motif — ajoutez-en un ci-dessus." }}
                columns={[
                    { title: "Motif", dataIndex: "libelleParametre", render: (v) => <Text>{v}</Text> },
                    {
                        title: "", key: "act", align: "right", width: 60,
                        render: (_, r) => <Button size="small" danger icon={<DeleteOutlined />} onClick={() => supprimer(r)} />,
                    },
                ]} />
        </div>
    );
};

const MotifsExclusionRetrocession = () => {
    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <SideBar currentMenu="AUTRES_PARAMETRES" />
                <div className="layout-page">
                    <NavBar />
                    <div className="content-wrapper">
                        <div className="container-xxl flex-grow-1 container-p-y">
                            <Card>
                                <div style={{ marginBottom: 12 }}>
                                    <Title level={4} style={{ color: PRIMARY, margin: 0 }}>
                                        Motifs d'exclusion de la rétrocession
                                    </Title>
                                    <Text type="secondary">
                                        Motifs paramétrables pour écarter une ligne (émission / annulation / sinistre payé / recours)
                                        d'un compte de cession lors de la rétrocession. <Tag color="blue">/retrocession</Tag>
                                    </Text>
                                </div>
                                <Tabs
                                    items={TYPES.map((t) => ({
                                        key: t.key,
                                        label: t.label,
                                        children: <MotifsParType paramType={t.param} />,
                                    }))}
                                />
                            </Card>
                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
            <div className="layout-overlay layout-menu-toggle"></div>
            <div className="drag-target"></div>
        </div>
    );
};

export default MotifsExclusionRetrocession;
